import { FC } from "react"

import { Flex } from "components/Flex"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"
import HelpButton from "components/HelpButton/HelpButton"
import { Clamp } from "@/types"
import { TableColumn } from "./Table"

interface ITableHeaderCellProps {
    col: TableColumn
    clamp?: Clamp
}

const TableHeaderCell: FC<ITableHeaderCellProps> = ({
    col,
    clamp,
}) => {
    return (
        <Flex alignItems="center" justifyContent="space-between" className="w-100">
            <Flex alignItems="center" className="w-100">
                <div className="table__head-label">
                    {typeof clamp === "number" && typeof col.title === "string"
                        ? <FlexibleContent text={col.title} clamp={clamp} />
                        : col.title
                    }
                </div>
                {!!col.explanation &&
                    <div className="ml-1">
                        <HelpButton tooltipProps={col.explanation} />
                    </div>
                }
            </Flex>
            {(col.sort || col.onSortChange) &&
                <div className={`table__sort table__sort--${col.sort || "inactive"}`}></div>
            }
        </Flex>
    )
}

export default TableHeaderCell
